// extracted by mini-css-extract-plugin
export default {"container":"container_cFuS_","title":"title_ldMCC","texts":"texts_uVnyb","textSmall":"textSmall_NPIQz"};